<div class="container">
  <img src="imgs/icon.png" class="logo-icon">
  <div class="title">
    MyMindLog
  </div>
  <div class="sub-title">
    {{'reset_password.reset' | translate}}
  </div>
  <div class="info">
    {{'reset_password.info' | translate}}
  </div>
  <div class="form-container">
    
    <form [formGroup]="resetForm" class="form">      
      <app-input 
        [label]="'labels.password' | translate"
        [placeholder]="'placeholders.password' | translate"
        [formControl]="passwordControl"
        type="password"
      ></app-input>

      <app-input 
        [label]="'labels.confirm_password' | translate"
        [placeholder]="'placeholders.confirm_password' | translate"
        [formControl]="passwordVerificationControl"
        type="password"
      ></app-input>
    </form>

    <div class="actions-container">
      <app-button 
        [buttonLabel]="'buttons.cancel' | translate"
        [buttonType]="BUTTON_TYPES.OUTLINED" 
        [buttonDisabled]="false"
        (click)="cancel()">
      </app-button>
      
      <app-button
        [buttonLabel]="'buttons.reset' | translate"
        [buttonType]="BUTTON_TYPES.REGULAR" 
        [buttonDisabled]="isFormInvalid()"
        (click)="resetPassword()">
      </app-button>
    </div>
    
  </div>
</div>